import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {SportHomePageContent} from "../../Common/pages/SportHomePageContent";

export default class RugbyUnionHomePage extends Component {
  static propTypes = {
    location: PropTypes.object
  };

  render() {
    const { location } = this.props;

    return <SportHomePageContent
      sport="rugby-union"
      title="Rugby Union Scores, Fixtures & Results"
      location={ location }
    />
  }
}



// WEBPACK FOOTER //
// ./modules/RugbyUnion/containers/RugbyUnionHomePage.js